module.exports = __webpack_public_path__ + "static/media/InjoyLifeResources.38a2193e.jpeg";